import { useContext, useMemo } from 'react';

import { StateContext } from '../control/state';
import { TraceLog } from '../data/misc';

export const useTurnsForThread = () => {
  const { traceLog } = useContext(StateContext);

  const threadGroupedByTurns = useMemo(() => {
    let currentTurnIndex = -1; // Start at -1 so first input creates turn 0
    return traceLog.reduce((acc, entry) => {
      // Start a new turn when we see an input source
      if (entry.meta.source === 'input' && entry.entry.type === 'checkpoint') {
        currentTurnIndex++;
      }

      // Initialize the array for this turn if it doesn't exist
      if (!acc[currentTurnIndex.toString()]) {
        acc[currentTurnIndex.toString()] = [];
      }

      acc[currentTurnIndex.toString()].push(entry);
      return acc;
    }, {} as Record<string, TraceLog[]>);
  }, [traceLog]);

  return {
    threadGroupedByTurns,
  };
};
